var React = require('react');
var moment = require('moment');
var _ = require('lodash');
var cx = require('classnames');
import { connect } from 'react-redux';
import actions from './actions';

class PeriodComparator extends React.Component {
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            firstPeriodStart: null,
            firstPeriodEnd: null
        };
    }
    
    componentDidUpdate() {
        if(!this.props.firstPeriodStart && !this.props.firstPeriodEnd) return;
    
        if(this.props.firstPeriodStart.format() !== this.state.firstPeriodStart || this.props.firstPeriodEnd.format() !== this.state.firstPeriodEnd){
            if(!this.props.popupcalendar && !this.props.static){
                const element = document.getElementsByClassName('selected-start')[0];
                if (element) {
                    var yOffset = -50;

                    var offsetElement = document.querySelector('[data-body-margin-top="true"]');
                    if(offsetElement){
                        yOffset -= offsetElement.offsetHeight;
                    }

                    const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: yCoordinate + yOffset,
                        behavior: 'smooth'
                    });
                }
            }

            const floatingbutton = document.getElementsByClassName('floating-booking-trigger');
            if(floatingbutton.length > 0){ 
                for(var i = 0; i < floatingbutton.length; i++){
                    if (!floatingbutton[i].classList.contains('button-availability-go')) {
                        floatingbutton[i].className += " button-availability-go";
                    }
                    floatingbutton[i].removeAttribute('onclick');
                }
            }
            
            this.setState({
                firstPeriodStart: this.props.firstPeriodStart.format(),
                firstPeriodEnd: this.props.firstPeriodEnd.format(),
            });
        }
    }

    noop(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    getFirstPeriodPriceBeforeDiscount() {

        var formatter =  new Intl.NumberFormat(window.CvrmLocale, {style: 'currency', currency: this.props.currency ? this.props.currency : 'EUR' , minimumFractionDigits: 2});
        var slashThrough = formatter.format(this.props.firstPeriodPriceBeforeDiscount);
        if (this.props.firstPeriodPriceBeforeDiscount != this.props.firstPeriodPrice) {
            return (<span className="slashthrough">{slashThrough}</span>);
        } 
    }
    getFirstPeriod() {
        if (this.props.static) return null;
        if (this.props.firstPeriodStart && this.props.firstPeriodEnd) {
            var formatter =  new Intl.NumberFormat(window.CvrmLocale, {style: 'currency', currency:  this.props.currency ? this.props.currency : 'EUR', minimumFractionDigits: 2});
            var pricePerPersonAndDayUnformatted = (this.props.firstPeriodPrice / this.props.numPeople / (1 + this.props.firstPeriodEnd.diff(this.props.firstPeriodStart, 'days')));
            var pricePerPersonAndDay = formatter.format((this.props.currency !== 'EUR') ? pricePerPersonAndDayUnformatted * this.props.currencyRate : pricePerPersonAndDayUnformatted); 
            var firstPeriodPrice = formatter.format((this.props.currency !== 'EUR') ? this.props.firstPeriodPrice * this.props.currencyRate : this.props.firstPeriodPrice);
            
            return (
                <div className="calendar-row mb-3">
                        <div className="row">
                            <div className="col-sm-6 mb-3">    
                                <div className="bg-grey3 p-3 border-radius-default flex items-center">
                                    <img src="/assets/img/front/icons/calendar-blue3.svg" height="16" width="16" alt="calendar" className="mr-1" />
                                    <span className="font-w600 mr-1 capitalize">{ this.props.t.trans('arrival', {}, 'messages').replace(/:/gi,'')}:</span>
                                    <span>{this.props.firstPeriodStart.format('DD/MM/YY')}</span>
                                </div>
                            </div>
                            <div className="col-sm-6 mb-3">
                                <div className="bg-grey3 p-3 border-radius-default flex items-center">
                                    <img src="/assets/img/front/icons/calendar-blue3.svg" height="16" width="16" alt="calendar" className="mr-1" />
                                    <span className="font-w600 mr-1 capitalize">{  this.props.t.trans('departure', {}, 'messages').replace(/:/gi,'').toLowerCase()}:</span>
                                    <span>{this.props.firstPeriodEnd.clone().add(1, 'day').format('DD/MM/YY')}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 mb-3">
                                <div className="your-price">
                                    <div className={this.props.vertical ? 'btn btn-secondary bg-orange3 uppercase text-center cursor-force' : 'btn btn-primary uppercase text-center cursor-force bg-blue3-hover'}>
                                        <span className="your-price-label">{  this.props.t.trans('calendar.yourprice', {}, 'messages')}</span>
                                        <span className="period-price">
                                            {this.getFirstPeriodPriceBeforeDiscount()}
                                            <span className="ml-2 "><strong>{firstPeriodPrice}</strong></span>
                                        </span>
                                    </div>
                                </div>

                                { this.props.bookingType === 'booking-option'  ?
                                    <input type="hidden" id="cvrm_booking_option_stayRange_daterangepicker" name="cvrm_booking_option[stayRange]" onKeyDown={this.noKeyDown} value={this.props.firstPeriodStart.format('DD/MM/YYYY') +' -- '+ this.props.firstPeriodEnd.clone().add(1, 'day').format('DD/MM/YYYY')}/>
                                :
                                    <input type="hidden" id="cvrm_booking_stayRange_daterangepicker" name="cvrm_booking[stayRange]" onKeyDown={this.noKeyDown} value={this.props.firstPeriodStart.format('DD/MM/YYYY') +' -- '+ this.props.firstPeriodEnd.clone().add(1, 'day').format('DD/MM/YYYY')}/>
                                }
                            </div>
                            <div className="col-sm-6 mb-3">
                                <button className="uppercase btn btn-secondary button-availability-go btn-block" onClick={this.clickNext}><span>{ this.props.buttonTitle }{ this.props.buttonSubtitle }</span></button>
                                { this.props.cleaningIncluded  && (
                                <div class="booking-included blue1 font-90 border-radius-default bor-blue1-single mt-3 p-3 {{ stayStart  and stayEnd ? '' : 'hide' }}">
                                    { this.props.t.trans('price_includes', {}, 'messages')} <span style={{ textTransform: 'capitalize' }}>{this.props.t.trans('cleaning', {}, 'messages') }</span>
                                </div>
                                )}

                                { false && !this.props.confirmWithOwner &&  (
                                    <>
                                    <div className="width-100 text-center my-1 blue1">{this.props.t.trans('or')}</div>
                                    <button className="uppercase btn btn-primary button-option-go btn-block" onClick={this.clickNext}><span>{ this.props.t.trans('booking_option_hold.take_option', {}, 'messages') }</span></button>
                                    </>
                                    )
                                }
                            </div>
                            <div className="col-sm-12">
                                *<span className="font-90">{pricePerPersonAndDay} {  this.props.t.trans('calendar.price_per_person', {}, 'messages')}</span>
                            </div>
                        </div>
                </div>
                );
                // Go to step 2:
                // Customize »
        } else {
        var style = {
      fontSize: 22,
      marginTop: 10,

    };
            return (
            <div>
                <div className="p-3 bg-grey3 border-radius-default select-period-text text-center animation-element uppercase my-3"><strong>{  this.props.t.trans('calendar.selectperiodtocalculate', {}, 'messages')}</strong></div>
            </div>
        )
        }
    }
    clickNext() {
        window._setters.loading.on();
    }
    
    noKeyDown(){
        e.preventDefault();
        e.stopPropagation();
    }
    
    render() {
        const style = {
            display: this.props.popupcalendar ? 'none' :'block'
        };
        
        return (
            <div className="calendar-selected mt-3" style={style}>
                <div className="period_2">
                    {this.getFirstPeriod()}
                </div>
            </div>);
    }
}

const mapStateToProps = (state) => ({
    firstPeriodStart: state.calendarStore.firstPeriodStart,
    firstPeriodEnd: state.calendarStore.firstPeriodEnd,
    firstPeriodPrice: state.calendarStore.firstPeriodPrice,
    firstPeriodPriceBeforeDiscount: state.calendarStore.firstPeriodPriceBeforeDiscount,
    numPeople: state.calendarStore.numPeople,
    buttonTitle: state.calendarStore.buttonTitle,
    buttonSubtitle: state.calendarStore.buttonSubtitle,
    currency: state.calendarStore.currency,
    currencyRate: state.calendarStore.currencyRate,
    bookingType: state.calendarStore.bookingType,
    confirmWithOwner: state.calendarStore.confirmWithOwner,
    cleaningIncluded: state.calendarStore.cleaningIncluded,
    vertical: state.calendarStore.vertical,
});

export default connect(mapStateToProps)(PeriodComparator);
